import { XMarkIcon } from '@heroicons/react/24/outline';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const ProgrammeFilterComponent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const programmeName = searchParams.get('programmeName');
  const onClearProgrammeFilter = () => {
    navigate('/missions');
  };

  if (!programmeName) return null;

  return (
    <div className="my-4">
      <p className="mb-2 font-cadiz text-sh-xs font-bold">Programme</p>

      <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm">
        <span className="text-gray-700">{programmeName}</span>
        <button
          type="button"
          onClick={onClearProgrammeFilter}
          className="flex h-5 w-5 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
          aria-label="Clear programme filter">
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
